import { render, staticRenderFns } from "./ProductionCosts.vue?vue&type=template&id=7efe04ee&scoped=true"
import script from "./ProductionCosts.vue?vue&type=script&lang=js"
export * from "./ProductionCosts.vue?vue&type=script&lang=js"
import style0 from "./ProductionCosts.vue?vue&type=style&index=0&id=7efe04ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efe04ee",
  null
  
)

export default component.exports